import { BehaviorSubject, zip } from "rxjs";
import { take } from "rxjs/operators";

class Object3DManager {
  objects = {};
  objects$ = {};

  constructor(world) {
    this.world = world;
  }

  getObject3D(id, type = "mesh") {
    return this.objects[id];
  }

  setObject3D(id, obj) {
    if (this.objects[id]) {
      // TODO: if obj exists ... remove old primitive from its parent (${id})
      process.env.NODE_ENV === "development" && console.log(`Warning: Object3D ID already exists (${id}).`);
    }
    this.objects[id] = obj;

    if (obj.material) {
      if (Array.isArray(obj.material)) {
        // mark initial materials
        obj.material.forEach((mat) => {
          mat.userData = { initialMaterial: true };
        });

        // Note: zip: After all observables emit, emit values as an array
        // If some material with given name is missing this won't emit
        zip(
          ...obj.material.map((material) =>
            this.world.materialManager.getMaterial$(material.name)
          )
        )
          .pipe(take(1))
          .subscribe((materials) => {
            if (
              Array.isArray(obj.material) &&
              obj.material.length === materials.length
            ) {
              obj.material = obj.material.map((oldMaterial, index) => {
                if (
                  oldMaterial.userData.initialMaterial &&
                  materials[index] &&
                  oldMaterial !== materials[index]
                ) {
                  return materials[index];
                }
                return oldMaterial;
              });
            }
          });
      } else {
        // mark initial materials
        obj.material.userData = { initialMaterial: true };

        // single material case
        this.world.materialManager
          .getMaterial$(obj.material.name)
          .pipe(take(1))
          .subscribe((material) => {
            // override initial material
            if (material && obj.material.userData.initialMaterial) {
              obj.material = material;
            }
          });
      }
    }

    const object$ = this.getObject3D$(id);
    object$.next(obj);
    return this.objects[id];
  }

  getObject3D$(id) {
    if (!this.objects$[id]) {
      this.objects$[id] = new BehaviorSubject();
    }
    return this.objects$[id];
  }
}

export default Object3DManager;
